<template>
  <div v-if="is_visible" class="fixed flex items-center justify-center papsi-modal-overlay" 
    :style="{ backgroundColor: overlay_enabled ? overlay_background : 'transparent' }" 
    style="z-index: 55;" 
    @click.self="closeModal">
      <div :class="[modalSizeClass, scrollableClass]" class="bg-white rounded-xl p-10">
          <div class="modal-body">
              <slot></slot>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "v-modal",
  props: {
    is_visible: {
      type: Boolean,
      required: true,
    },
    is_table: {
      type: Boolean,
      default: false,
    },
    is_qr: {
      type: Boolean,
      default: false,
    },
    is_scrollable: {
      type: Boolean,
      default: false,
    },
    overlay_enabled: {
      type: Boolean,
      default: true,
    },
    overlay_background: {
      type: String,
      default: "rgba(0, 0, 0, 0.7)",
    },
    title: {
      type: String, 
    }
  },
  computed: {
    modalSizeClass() {
      if (this.is_table) {
        return 'w-5/6';
      } else if (this.is_qr) {
        return 'w-1/3';
      } else {
        return 'w-1/2';
      }
    },
    scrollableClass() {
      return this.is_scrollable ? 'max-h-80 overflow-y-auto' : '';
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
  .papsi-modal-overlay {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.7);
  }


</style>